/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export interface IMapFunctionScope extends angular.IScope {
        mapFunction: Wars.Domain.Model.Gis.MapFunctionConfiguration;
        includedMapFunction:Wars.Domain.Model.Gis.IncludedMapFunction;
    }

    export class MapFunction implements IDirective{
        public link($scope: IDrawStyleScope, element: JQuery, attrs: ng.IAttributes) {
        }

        public templateUrl = "./app/views/directives/gis/mapFunction.html";
        public restrict: string = "E";
        public controller = ["$scope",'mapConfigurationService',MapFunctionController];
        public controllerAs = "controller";
        public scope: any = {
            mapFunction: "=",
            includedMapFunction: "=",
        };
    }

    export class MapFunctionController {
        constructor($scope:IMapFunctionScope, mapConfigurationService: services.MapConfigurationService) {

        }
    }
}

warsApp.registerDirective('MapFunction',[]);
